import { QueryClient } from '@tanstack/react-query';
import { QueryClientProvider as QueryProvider } from '@tanstack/react-query';

const queryClient = new QueryClient();

export function QueryClientProvider({ children }: { children?: React.ReactNode }) {
  return <QueryProvider client={queryClient}>{children}</QueryProvider>;
}
